_ = require 'underscore'

getQueryParams = ->
  queryString = window.location.search
  _.chain(queryString.substring(1).split('&'))
    .map (param) -> param.split('=')
    .object()
    .value()

getQueryParamByKey = (key) -> getQueryParams()[key]

module.exports = getQueryParamByKey



// WEBPACK FOOTER //
// ./app/scripts/lib/util/url/get-query-param-by-key.coffee